import { Component } from 'react'
import styled from 'styled-components'

import Panel from '../display/Panel'
import ChevronDown from '../icons/ChevronDown'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 18px;
  margin: 8px 0 8px;
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme?.['-ds-error-300']?.value : theme.colors.textGreyLight};

  background-color: ${({ white }) => (white ? 'white' : 'transparent')};

  &:focus {
    border-color: ${({ theme }) => theme.brand.jungle};
  }

  color: black;

  select {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 18px;

    appearance: none;
    overflow: hidden;
    background: transparent;
    color: currentColor;
    border: 0;
    outline: 0;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    pointer-events: none;
    top: 0;
    right: 0;

    height: 100%;
    padding: 0 18px;
  }

  svg {
    width: 13px;
    height: 6px;
  }
`

const Trigger = styled.button.attrs({ type: 'button' })`
  appearance: none;
  background-color: #fff;

  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 18px;

  text-align: left;
  border: 0;

  ${({ roundedLeft, open }) => {
    if (roundedLeft) {
      if (open) {
        return `
          border-top-left-radius: 6px;
        `
      }

      return `
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      `
    }

    return ``
  }}
`

const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;

  margin: 0;
  padding: 0;

  text-align: left;

  background: white;
  border: 1px solid ${({ theme }) => theme.colors.textGreyLight};

  z-index: 999;

  li {
    display: block;
    padding: 18px;
    outline: 0;

    border-bottom: 1px solid ${({ theme }) => theme.colors.textGreyLight};

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      cursor: pointer;
      background: white;
      color: ${({ theme }) => theme.brand.jungle};
    }

    &.selected {
      color: white;
      background: ${({ theme }) => theme.brand.jungle};
    }
  }

  ${({ roundedBottom }) =>
    roundedBottom &&
    `
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;
  `}
`

export default class DropdownField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  onToggle = () => {
    const { open: prev } = this.state

    this.setState({
      open: !prev,
    })
  }

  onClose = () => {
    this.setState({
      open: false,
    })
  }

  handleChange = (code) => {
    const {
      input: { onChange },
    } = this.props
    onChange(code)
    this.onClose()
  }

  render() {
    const {
      input: { value },
      meta: { error, submitFailed },
      placeholder,
      items,
      white,
      roundedLeft,
      roundedDropdown,
    } = this.props

    const { open } = this.state
    const selectedItem = items.find((item) => item.id === value)
    return (
      <Wrapper
        className="dropdown-field"
        white={white}
        error={error && submitFailed}
      >
        &nbsp;
        <Trigger onClick={this.onToggle} roundedLeft={roundedLeft} open={open}>
          {selectedItem ? selectedItem.label : placeholder}
        </Trigger>
        <Panel open={open} onClose={this.onClose}>
          <Dropdown roundedBottom={roundedDropdown}>
            {items.map(({ id, label }, index) => (
              <li
                key={id}
                role="menuitem"
                tabIndex={index}
                className={id === value ? 'selected' : ''}
                onClick={() => this.handleChange(id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') this.handleChange(id)
                }}
              >
                {label}
              </li>
            ))}
          </Dropdown>
        </Panel>
        <span>
          <ChevronDown />
        </span>
      </Wrapper>
    )
  }
}
